import Instance from "../../../../Axios";

// New Actions for the app

const GetCredEmpresas = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/empresas`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_EMPRESAS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredEmpresas;